import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useMemo } from 'react';
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { QueryKeys } from '../queryKeys';
import { useQueryState } from '../useQueryState';
const useServiceNameOptions = (param)=>{
    let { queryKey, fetchNames, enabled = true, refreshOnHookMount = false } = param;
    const businessId = useStore(selectors.user.businessId);
    const { data } = useQueryState({
        queryKey: [
            ...queryKey,
            businessId
        ],
        queryFn: ()=>fetchNames(businessId),
        enabled: enabled && businessId != null,
        refreshOnHookMount
    });
    return useMemo(()=>(data !== null && data !== void 0 ? data : []).map((param)=>{
            let { name, isBundle } = param;
            return {
                id: name,
                name,
                body: '',
                isBundle
            };
        }), [
        data
    ]);
};
export const useDraftServiceNameOptions = function useDraftServiceNameOptions() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    return useServiceNameOptions(_object_spread_props(_object_spread({}, options), {
        queryKey: [
            QueryKeys.DraftServiceNames
        ],
        fetchNames: ()=>api.draft.getServiceNames()
    }));
};
export const useAgreementServiceNameOptions = function useAgreementServiceNameOptions(isVendor) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    return useServiceNameOptions(_object_spread_props(_object_spread({}, options), {
        queryKey: [
            QueryKeys.AgreementServiceNames,
            isVendor
        ],
        fetchNames: (businessId)=>api.relationship.getServiceNames(businessId, isVendor)
    }));
};
